import { useEffect, useState } from "react";
import api from 'services/api';
import CustomProgressBar from "components/progressbar";
import './style.css';
import { getcodCidade, getnome } from "functions/gettabconfig";
import config from 'config';
import CarrosselCupons from "components/carrosselCupons";

function MeuConquista() {

    const [cupons, SetCupons] = useState([])
    const [cuponsunicos, SetCuponsUnicos] = useState([])    
    const [saldo, SetSaldo] = useState(0)
    const [progress, setProgress] = useState(100);

    useEffect(() => {
        api.get(`${config.CUPONS}?cod_cidade=${getcodCidade()}`)
            .then(response => {
                if (response.data[0].cupons === undefined) {
                    SetSaldo(0)
                    SetCupons([])
                    setProgress(0);
                    SetCuponsUnicos([])
                } else {
                SetSaldo(response.data[0].saldo)
                SetCupons(response.data[0].cupons)
                setProgress((response.data[0].saldo / 1) * 100);
                const uniqueIdSorteio = [...new Set(response.data[0].cupons.map(cupom => cupom.id_sorteio))]
                SetCuponsUnicos(uniqueIdSorteio)
                }
            });

    }, [])

    return (
        <div>
            <h1 className="section-title">
                <i className="fas fa-trophy" style={{marginRight: '12px'}}></i>
                Minhas Conquistas
            </h1>

            <div className="row">
                <div className="col-lg-10">
                    <div className="conquistas-welcome">
                        <h4>Olá {getnome()}</h4>
                        <h6 className="card-ola-title">veja suas conquistas e benefícios hoje</h6>
                        
                        <div className="conquistas-stats">
                            <div className="stat-item">
                                <span className="stat-value">{cuponsunicos.length ?? 0}</span>
                                <span className="stat-label">Cupons Acumulados</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-value">{saldo ?? 0}</span>
                                <span className="stat-label">Pontos de Saldo</span>
                            </div>
                        </div>
                    </div>

                    <div className="progress-section">
                        <div className="progress-header">
                            <span className="progress-title">Progresso até o próximo cupom</span>
                            <span className="progress-value">{Math.floor(progress)}%</span>
                        </div>
                        <CustomProgressBar 
                            progress={progress}
                            label={Math.floor(progress).toString() + '%'} 
                        />
                    </div>

                    {cuponsunicos.length > 0 && (
                        <div className="cupons-numeros-container">
                            <h2>Seus Números da Sorte</h2>
                            <div className="cupons-grid">
                                {cuponsunicos.map((c, index) => (
                                    <div key={`ncupons${index}`} className="cupom-numero">
                                        {c}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <CarrosselCupons lcupons={cupons} />
                </div>
            </div>
        </div>
    );
}

export default MeuConquista;